export interface InventoryColumn {
  id: string;
  label: string;
  width: string;
  sortable: boolean;
  align?: 'left' | 'center' | 'right';
}

export const INVENTORY_COLUMNS: InventoryColumn[] = [
  { id: 'listed', label: 'Status', width: 'w-[50px]', sortable: false, align: 'center' },
  { id: 'image', label: 'Image', width: 'w-[60px]', sortable: false },
  // Mobile: fixed width for early truncation. Desktop: flex to consume remaining space.
  { id: 'title', label: 'Title', width: 'w-[160px] shrink-0 md:flex-1 md:basis-[260px] md:min-w-0', sortable: false },
  { id: 'condition', label: 'Condition', width: 'w-[100px]', sortable: false },
  { id: 'category', label: 'Category', width: 'w-[100px]', sortable: false },
  { id: 'price', label: 'Price', width: 'w-[100px]', sortable: false, align: 'right' },

];

export const CONDITION_LABELS: Record<string, string> = {
  // Singles conditions
  sealed: 'Sealed',
  mint: 'Mint',
  near_mint: 'NM',
  lightly_played: 'LP',
  moderately_played: 'MP',
  heavily_played: 'HP',
  damaged: 'DMG',
  // Sealed product conditions
  factory_sealed: 'FS',
  factory_sealed_minor: 'FS-',
  factory_sealed_major: 'FS--',
  resealed: 'RS',
  opened: 'Opened',
  // Accessory conditions
  new: 'New',
  like_new: 'LN',
  good: 'Good',
  fair: 'Fair',
};

export const CONDITION_COLORS: Record<string, string> = {
  // Singles conditions
  sealed: 'bg-info/20 text-info border-info/30',
  mint: 'bg-success/20 text-success border-success/30',
  near_mint: 'bg-success/20 text-success border-success/30',
  lightly_played: 'bg-caution/20 text-caution border-caution/30',
  moderately_played: 'bg-warning/20 text-warning border-warning/30',
  heavily_played: 'bg-warning/20 text-warning border-warning/30',
  damaged: 'bg-destructive/20 text-destructive border-destructive/30',
  // Sealed product conditions
  factory_sealed: 'bg-success/20 text-success border-success/30',
  factory_sealed_minor: 'bg-caution/20 text-caution border-caution/30',
  factory_sealed_major: 'bg-warning/20 text-warning border-warning/30',
  resealed: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  opened: 'bg-destructive/20 text-destructive border-destructive/30',
  // Accessory conditions
  new: 'bg-success/20 text-success border-success/30',
  like_new: 'bg-success/20 text-success border-success/30',
  good: 'bg-caution/20 text-caution border-caution/30',
  fair: 'bg-warning/20 text-warning border-warning/30',
};

export const CATEGORY_LABELS: Record<string, string> = {
  singles: 'Singles',
  sealed: 'Sealed',
  slabs: 'Slabs',
  lots: 'Lots',
  accessories: 'Accessories',
};
